// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Scanpopup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0,0.5); /* Semi-transparent black overlay */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999; /* Adjust the z-index to control stacking order */
  }
  
  /* Styles for the "Issue Description" section */
  .Scanissue-description {
    cursor: pointer;
    display: flex;
    color: white;
    padding: 20px;
    
    /* grid-template-columns: 6fr 1fr; */
  }
  .Scanissue-description pre {
    overflow: auto;
    word-wrap: break-word;
    max-width: 100%;
    max-height: 200px;
    white-space: pre-wrap;
    scrollbar-width: thin; /* For Firefox */
    padding-right: 15px;
  }
  .Scanissue-description pre::-webkit-scrollbar {
    width: 5px; /* Width of the scrollbar */
  }
  .Scanissue-description pre::-webkit-scrollbar-track {
    background-color: transparent; /* Color behind the scrollbar */
    width: 2px;
    /* scrollbar-track-color: transparent; */
  }
  
  .Scanissue-description pre::-webkit-scrollbar-thumb {
    background-color: white; /* Color of the scrollbar thumb */
    border-radius: 5px; /* Rounded corners for the thumb */
  }
  /* .issue-description label {
  margin-bottom: 10px;
  } */
  
  /* Styles for the popup content */
  .Scanpopup-title {
    /* background: #fff; Background color for the popup */
    /* background-color: rgba(54, 62, 59); */
    background-color: #2E2F30;
  display: flex;
    padding: 0px;
    border-radius: 1px;
    color: white;
    width: 100%;
    height: 45px;
    align-items: center;
    justify-content: center;
  
    }
  .Scanpopup-content {
    /* background: #fff; Background color for the popup */
    /* background-color: rgba(54, 62, 59); */
    background-color: #222324;
    /* background-color: rgba(54, 62, 59,0.8); */
    /* background: #fff; */
    padding: 0px;
    border-radius: 5px;
    color: white;
    width: 50%;
    /* box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2); Box shadow for a subtle lift effect */
    text-align: center;
    }
  
  /* Styles for the "Yes" and "No" buttons */
 .Scanbutton {
    margin: 20px;
    padding: 10px 20px;
    border: none;
    -webkit-text-decoration: solid;
            text-decoration: solid;
    border-radius: 5px;
    cursor: pointer;
  }
  
  /* Scanbutton:hover {
   
    color: #222324;
  }
  

  Scanbutton:first-child {
    margin-right: 10px;
  } */
  .ScanyesButton {
    background-color: #DE8500;
    color:white;
  }
  .ScancloseButton{
    margin-top: -20px;
    background-color: #6E757A;
    color:white;
  }
  
  `, "",{"version":3,"sources":["webpack://./src/Components/Dialog/popUpReport.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,6BAA6B,EAAE,mCAAmC;IAClE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY,EAAE,iDAAiD;EACjE;;EAEA,+CAA+C;EAC/C;IACE,eAAe;IACf,aAAa;IACb,YAAY;IACZ,aAAa;;IAEb,oCAAoC;EACtC;EACA;IACE,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB,EAAE,gBAAgB;IACvC,mBAAmB;EACrB;EACA;IACE,UAAU,EAAE,2BAA2B;EACzC;EACA;IACE,6BAA6B,EAAE,+BAA+B;IAC9D,UAAU;IACV,wCAAwC;EAC1C;;EAEA;IACE,uBAAuB,EAAE,iCAAiC;IAC1D,kBAAkB,EAAE,kCAAkC;EACxD;EACA;;KAEG;;EAEH,iCAAiC;EACjC;IACE,qDAAqD;IACrD,wCAAwC;IACxC,yBAAyB;EAC3B,aAAa;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;;IAEvB;EACF;IACE,qDAAqD;IACrD,wCAAwC;IACxC,yBAAyB;IACzB,4CAA4C;IAC5C,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,qFAAqF;IACrF,kBAAkB;IAClB;;EAEF,0CAA0C;CAC3C;IACG,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,8BAAsB;YAAtB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;;;;;;;KAQG;EACH;IACE,yBAAyB;IACzB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;EACb","sourcesContent":[".Scanpopup {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 0, 0,0.5); /* Semi-transparent black overlay */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 999; /* Adjust the z-index to control stacking order */\r\n  }\r\n  \r\n  /* Styles for the \"Issue Description\" section */\r\n  .Scanissue-description {\r\n    cursor: pointer;\r\n    display: flex;\r\n    color: white;\r\n    padding: 20px;\r\n    \r\n    /* grid-template-columns: 6fr 1fr; */\r\n  }\r\n  .Scanissue-description pre {\r\n    overflow: auto;\r\n    word-wrap: break-word;\r\n    max-width: 100%;\r\n    max-height: 200px;\r\n    white-space: pre-wrap;\r\n    scrollbar-width: thin; /* For Firefox */\r\n    padding-right: 15px;\r\n  }\r\n  .Scanissue-description pre::-webkit-scrollbar {\r\n    width: 5px; /* Width of the scrollbar */\r\n  }\r\n  .Scanissue-description pre::-webkit-scrollbar-track {\r\n    background-color: transparent; /* Color behind the scrollbar */\r\n    width: 2px;\r\n    /* scrollbar-track-color: transparent; */\r\n  }\r\n  \r\n  .Scanissue-description pre::-webkit-scrollbar-thumb {\r\n    background-color: white; /* Color of the scrollbar thumb */\r\n    border-radius: 5px; /* Rounded corners for the thumb */\r\n  }\r\n  /* .issue-description label {\r\n  margin-bottom: 10px;\r\n  } */\r\n  \r\n  /* Styles for the popup content */\r\n  .Scanpopup-title {\r\n    /* background: #fff; Background color for the popup */\r\n    /* background-color: rgba(54, 62, 59); */\r\n    background-color: #2E2F30;\r\n  display: flex;\r\n    padding: 0px;\r\n    border-radius: 1px;\r\n    color: white;\r\n    width: 100%;\r\n    height: 45px;\r\n    align-items: center;\r\n    justify-content: center;\r\n  \r\n    }\r\n  .Scanpopup-content {\r\n    /* background: #fff; Background color for the popup */\r\n    /* background-color: rgba(54, 62, 59); */\r\n    background-color: #222324;\r\n    /* background-color: rgba(54, 62, 59,0.8); */\r\n    /* background: #fff; */\r\n    padding: 0px;\r\n    border-radius: 5px;\r\n    color: white;\r\n    width: 50%;\r\n    /* box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2); Box shadow for a subtle lift effect */\r\n    text-align: center;\r\n    }\r\n  \r\n  /* Styles for the \"Yes\" and \"No\" buttons */\r\n .Scanbutton {\r\n    margin: 20px;\r\n    padding: 10px 20px;\r\n    border: none;\r\n    text-decoration: solid;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  /* Scanbutton:hover {\r\n   \r\n    color: #222324;\r\n  }\r\n  \r\n\r\n  Scanbutton:first-child {\r\n    margin-right: 10px;\r\n  } */\r\n  .ScanyesButton {\r\n    background-color: #DE8500;\r\n    color:white;\r\n  }\r\n  .ScancloseButton{\r\n    margin-top: -20px;\r\n    background-color: #6E757A;\r\n    color:white;\r\n  }\r\n  \r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
